"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringLike = exports.LiteralString = exports.LiquidString = exports._LiquidString = void 0;
const zod_1 = require("zod");
const liquidjs_1 = require("liquidjs");
const engine = new liquidjs_1.Liquid();
exports._LiquidString = zod_1.z.string().superRefine((val, ctx) => {
    try {
        engine.parse(val);
    }
    catch {
        ctx.addIssue({
            validation: "regex",
            code: zod_1.z.ZodIssueCode.invalid_string,
            message: "Invalid Liquid template",
        });
    }
});
exports.LiquidString = zod_1.z.object({
    type: zod_1.z.literal("liquid"),
    value: exports._LiquidString,
});
exports.LiteralString = zod_1.z.object({
    type: zod_1.z.literal("literal"),
    value: zod_1.z.string(),
});
/*
 * This is used to allow for different types of strings
 * which can be used in the bar.
 */
exports.StringLike = zod_1.z.union([zod_1.z.string(), exports.LiquidString, exports.LiteralString]);
